/**
 * Compute some classes for styling: first/last of week, first/last of month
 * @param {import("react-calendar").CalendarTileProperties} props
 */
export const getTileClassName = props =>
  [
    props.date.getDate() === 1 ? "first-of-month" : null,
    props.date.getDate() ===
    new Date(props.date.getFullYear(), props.date.getMonth() + 1, 0).getDate()
      ? "last-of-month"
      : null,
    props.date.getDay() === 1 ? "first-of-week" : null,
    props.date.getDay() === 0 ? "last-of-week" : null,
    new Date(
      props.date.getFullYear(),
      props.date.getMonth(),
      props.date.getDate() + 7
    ).getMonth() !== props.date.getMonth()
      ? "last-seven-days"
      : null
  ].filter(s => s !== null);
